import React, { useEffect, memo, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';

import styles from './PinPopClose.module.less';
import { PCStoreJsBridge } from '../nativeapi';
import { logging } from '../actions/log';
import { setPinPopCloseVisible } from '../actions/layout';
import { DOWNLOAD_FINISHED, DOWNLOAD_ING } from '../constants/softstatus';

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);
const selectDownloadSofts = createSelector(
  state => state.download,
  download => download.softs,
);

export default memo(() => {
  const dispatch = useDispatch();
  const logInfoData = useSelector(selectLogInfo);
  const softs = useSelector(selectDownloadSofts);

  const handleClose = useCallback(() => {
    // 关闭时统计 正在下载中正在安装中应用个数
    const downloadSofts = [];
    const installSofts = [];
    softs.forEach(soft => {
      if (soft.status === DOWNLOAD_ING) {
        downloadSofts.push(soft.androidType === '1' ? soft.packageName : soft.softID);
      } else if (soft.status === DOWNLOAD_FINISHED) {
        installSofts.push(soft.androidType === '1' ? soft.packageName : soft.softID);
      }
    });

    // 快捷方式弹窗 直接退出
    dispatch(
      logging({
        category: 'C',
        action: 'Install_Protect_CloseWindow',
        label: '',
        param2: {
          source: 'Install_Protect',
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
          downloadSofts: downloadSofts.join(','),
          installSofts: installSofts.join(','),
        },
      }),
    );
    PCStoreJsBridge.closeWindow();
  }, [dispatch, softs]);

  const handleClosePin = useCallback(
    flag => {
      // 快捷方式弹窗 暂不退出 关闭弹窗
      dispatch(
        logging({
          category: 'C',
          action: flag ? 'Install_Protect_CloseDialog_X' : 'Install_Protect_CloseDialog',
          label: '',
          param2: {
            source: 'Install_Protect',
            source_p: logInfoData.source_p,
            source_pp: logInfoData.source_pp,
          },
        }),
      );
      dispatch(setPinPopCloseVisible(false));
    },
    [dispatch],
  );

  useEffect(() => {
    // 快捷方式弹窗 PV
    dispatch(
      logging({
        category: 'P',
        action: 'Install_Protect',
        label: '',
        param2: {
          source: 'Install_Protect',
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
        },
      }),
    );
  }, [dispatch]);

  return (
    <div className={styles.pinpop}>
      <div className="header">
        <span className="title">温馨提示</span>
        <span className="close iconfont icon-close" onClick={() => handleClosePin(true)} />
      </div>
      <div className="message">
        您还有未完成的下载任务，现在关闭软件商店将中断任务，确定退出吗？
      </div>
      <div className="btn-wrapper">
        <span className="btn_default" onClick={() => handleClose()}>
          直接退出
        </span>
        <span className="btn_primary" onClick={() => handleClosePin()}>
          暂不退出
        </span>
      </div>
    </div>
  );
});
